import b from 'b_';
import { ArrowShortBold } from 'education-icons';
import React from 'react';

import { Button, ButtonProps } from '../button/button';

import './arrow-button.scss';

export enum ArrowButtonDirection {
    RIGHT = 'right',
    LEFT = 'left',
    TOP = 'top',
    BOTTOM = 'bottom',
}

interface Props {
    onClick?: ButtonProps['onClick'];
    direction: ArrowButtonDirection;
    'aria-label'?: string;
    'aria-hidden'?: boolean;
}

export const ArrowButton = ({ direction, onClick, 'aria-label': ariaLabel, 'aria-hidden': ariaHidden }: Props) => (
    <Button
        aria-hidden={ariaHidden}
        aria-label={ariaLabel}
        className={b('arrow-button', { direction })}
        icon={<ArrowShortBold />}
        onClick={onClick}
        rounded
        size={Button.SIZE.L}
        view={Button.VIEW.RAISED}
    />
);

ArrowButton.DIRECTION = ArrowButtonDirection;
